import { render, staticRenderFns } from "./riskItem.vue?vue&type=template&id=5e87eb0a"
import script from "./riskItem.vue?vue&type=script&lang=js"
export * from "./riskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e87eb0a')) {
      api.createRecord('5e87eb0a', component.options)
    } else {
      api.reload('5e87eb0a', component.options)
    }
    module.hot.accept("./riskItem.vue?vue&type=template&id=5e87eb0a", function () {
      api.rerender('5e87eb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/riskItem.vue"
export default component.exports